import { useContext } from 'react'
import { useWindowSize } from 'react-use'
import { IconComponent } from 'ui'
import { CopilotContext } from '../context'
import { CopilotSidebarContext } from '../contexts/sidebar'
import Import from './import'
import Presets from './presets'
import { Button, Header, Section, Sidebar } from './style'

const CopilotSidebar = () => {
    const { disabled } = useContext(CopilotContext)
    const { isSidebarOpen, closeSidebar, openSidebar } = useContext(CopilotSidebarContext)
    const { width: windowWidth } = useWindowSize()
    const isTooSmallForButton = windowWidth < 1440

    if (disabled) {
        return null
    }

    return (
        <>
            {!isSidebarOpen && !isTooSmallForButton && (
                <Button
                    icon={<IconComponent icon="sidebar" height={18} width={18} />}
                    size="small"
                    onClick={openSidebar}
                >
                    Open Staff Mode
                </Button>
            )}
            <Sidebar open={isSidebarOpen} side="right">
                <Header title="Staff Mode" onClose={closeSidebar} />
                <Section defaultOpen icon="source" title="Import Presets">
                    <Import />
                </Section>
                <Section defaultOpen icon="flash" title="Manage Presets">
                    <Presets />
                </Section>
            </Sidebar>
        </>
    )
}

export default CopilotSidebar
